import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { jen_configUrl } from '@/config/index.js'

const routes = [
    {
        path: '/',
        redirect: "/home",
    },
    {
        path: '/home',
        name: 'home',
        redirect: "/home/find",
        component: () => import('../views/home/home.vue'),
        children: [
            {
                path: '/home/find',
                name: 'find',
                component: () => import('../views/find')
            },

            {
                path: '/home/order',
                name: 'order',
                component: () => import('../views/order')
            },
            {
                path: '/home/product',
                name: 'product',
                component: () => import('../views/product')
            },
            // { // TODO 1.2内容，先隐藏
            //     path: '/home/productDetail',
            //     name: 'productDetail',
            //     component: () => import('../views/productDetail')
            // },
            // {// 1.5.1版本去除解决方案模块
            //     path: '/home/Solution',
            //     name: 'Solution',
            //     component: () => import('../views/Solution')
            // },
            {
                path: '/home/resourceCenter',
                name: 'resourceCenter',
                component: () => import('../views/resourceCenter')
            },
            {
                path: '/home/about',
                name: 'about',
                component: () => import('../views/about')
            },
            {
                path: '/home/newsdetail',
                name: 'newsDetail',
                component: () => import('../views/newsDetail')
            },
            {
                path: '/home/detail',
                name: 'detail',
                component: () => import('../views/detail')
            },
            {
                path: '/home/nonetwork',
                name: 'nonetwork',
                component: () => import('../views/noNetwork')
            },
            {
                path: '/home/controlsyshome',
                name: 'controlsyshome',
                component: () => import('../views/controlSysHome')
            },
            {
                path: '/home/controlsupport',
                name: 'controlsupport',
                component: () => import('../views/controlSupport')
            },
            {
                path: '/home/orderDetail',
                name: 'orderDetail',
                component: () => import('../views/orderDetail')
            },
            {
                path: '/home/controlinformation',
                name: 'controlinformation',
                component: () => import('../views/controlInformation')
            },
            {
                path: '/home/controlrealauth',
                name: 'controlRealAuth',
                component: () => import('../views/controlRealAuth')
            },
            {
                path: '/home/controluserauth',
                name: 'controluserauth',
                component: () => import('../views/controlUserAuth')
            },
            {
                path: '/home/controlDeveloperAuth',
                name: 'controlDeveloperAuth',
                component: () => import('../views/controlDeveloperAuth')
            },
            {
                path: '/home/controlenterauth',
                name: 'controlenterauth',
                component: () => import('../views/controlEnterAuth')
            },
            {
                path: '/home/controldetail',
                name: 'controldetail',
                component: () => import('../views/controlDetail')
            },
            {
                path: '/home/controldocument',
                name: 'controlDocument',
                component: () => import('../views/controlDocument')
            },
            {
                path: '/home/controlSysMsg',
                name: 'controlSysMsg',
                component: () => import('../views/controlSysMsg')
            },
            {
                path: '/home/searchResult',
                name: 'searchResult',
                component: () => import('../views/searchResult')
            },
            {
                path: '/downloadApp',
                name: 'DownloadApp',
                component: () => import('../views/downloadApp')
            },
            {
                path: '/downloads',
                name: 'Downloads',
                component: () => import('../views/downloads')
            },
            {
                path: '/newDownload',
                name: 'NewDownload',
                component: () => import('../views/newDownload')
            },
        ]
    },

    /*{
        path: '/controlhome',
        name: 'controlhome',
        redirect: "/controlhome/controlsyshome",
        component: () => import('../views/controlHome'),
        children: [
            {
                path: '/controlhome/controlsyshome',
                name: 'controlsyshome',
                component: () => import('../views/controlSysHome')
            },
            {
                path: '/controlhome/controlsupport',
                name: 'controlsupport',
                component: () => import('../views/controlSupport')
            },
            {
                path: '/controlhome/orderDetail',
                name: 'orderDetail',
                component: () => import('../views/orderDetail')
            },
            {
                path: '/controlhome/controlinformation',
                name: 'controlinformation',
                component: () => import('../views/controlInformation')
            },
            {
                path: '/controlhome/controlrealauth',
                name: 'controlRealAuth',
                component: () => import('../views/controlRealAuth')
            },
            {
                path: '/controlhome/controluserauth',
                name: 'controluserauth',
                component: () => import('../views/controlUserAuth')
            },
            {
                path: '/controlhome/controlenterauth',
                name: 'controlenterauth',
                component: () => import('../views/controlEnterAuth')
            },
            {
                path: '/controlhome/controldetail',
                name: 'controldetail',
                component: () => import('../views/controlDetail')
            },
            {
                path: '/controlhome/controldocument',
                name: 'controlDocument',
                component: () => import('../views/controlDocument')
            },
            {
                path: '/controlhome/controlSysMsg',
                name: 'controlSysMsg',
                component: () => import('../views/controlSysMsg')
            },
        ]
    },*/
    {
        path: '/pay',
        name: 'pay',
        component: () => import('../views/pay')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/register')
    },
    {
        path: '/forgetpassword',
        name: 'forgetpassword',
        component: () => import('../views/forgetPassword')
    },
]

const router = createRouter({
    // base:'/apps/cmros/'
    // history: createWebHashHistory(), // hash路由模式
    scrollBehavior(to, from, savedPosition) {
        // return 期望滚动到哪个的位置
        // vue2.0  x  y  控制
        // vue3.0  left  top 控制
        return { left: 0, top: 0 }
    },
    history: createWebHistory(jen_configUrl), // history路由模式
    // history: createWebHistory(), // history路由模式
    routes
})

export default router;